import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';
import { INestedPricingCategory } from 'src/api/getPricingCategories/types';
import { IPriceRule } from 'src/types/price.types';
import { buildExistingRuleSubtitle } from 'src/utils/priceRules/confirmationStrings';

export const UNCATEGORISED_ID = 'uncategorised';

export type CategorySelectOption = SelectedMultiOption & { disabled?: boolean; children?: CategorySelectOption[] };

export const pricingCategoriesToSelectOptions = (
  nestedCategories: INestedPricingCategory[],
  rules?: IPriceRule[],
): CategorySelectOption[] => {
  const ruleByCategory = new Map<string, IPriceRule>();
  rules?.forEach((r) => {
    const id = r.pricing_category?.id ?? r.pricing_category_id;
    if (id) ruleByCategory.set(id, r);
  });

  const mapCategory = (category: INestedPricingCategory): CategorySelectOption => {
    const categoryId = category.category_id ?? UNCATEGORISED_ID;
    const rule = ruleByCategory.get(categoryId);
    return {
      id: categoryId,
      label: category.name,
      ...(rule && { subtitle: `[disabled] ${buildExistingRuleSubtitle(rule, 'no values set')}`, disabled: true }),
      display_order: category.display_order,
      children: category.children?.map(mapCategory) || [],
    };
  };

  return nestedCategories?.map(mapCategory) || [];
};
